<template>
  <div class="app-trigger-tariff-info">
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'

export default {
  name: 'TriggerTariffInfo',
  data () {
    return {
      tariffs: {
        bookedTariff: null
      }
    }
  },
  watch: {
    tariffs: function (tariffs) {
      document.dispatchEvent(new CustomEvent('hideMNP', { detail: tariffs?.bookedTariff?.tariffId }))
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(gql`query tariffs {
        tariffs {
          bookedTariff {
            tariffId
          }
        }
      }`, this, 'tariffs')
    }
  }
}
</script>
